import React from "react";
import { Link } from "react-router-dom";
import ImagePlaceholder from "./ImagePlaceholder";

export const ProductCard = ({ perfume }) => {
  const displayName = perfume.name || `Profumo ${perfume.slot_number}`;
  const hasImage = Boolean(perfume.main_image);

  return (
    <Link
      to={`/profumo/${perfume.id}`}
      data-testid={`product-card-${perfume.slot_number}`}
      className="group block"
    >
      <div className="relative h-[320px] flex items-center justify-center overflow-hidden bg-[#F4F4F4]">
        {hasImage ? (
          <img
            src={perfume.main_image}
            alt={`${perfume.brand || ""} ${displayName}`.trim()}
            loading="lazy"
            className="max-w-[75%] max-h-[75%] w-auto h-auto object-contain object-center transition-transform duration-700 ease-out group-hover:scale-105"
          />
        ) : (
          <ImagePlaceholder />
        )}

        <div className="absolute top-4 left-4 right-4 flex items-center justify-between gap-2">
          {perfume.size_ml ? (
            <span className="uppercase tracking-[0.22em] text-[10px] text-black/60 bg-white/80 backdrop-blur px-2 py-1">
              {perfume.size_ml}
            </span>
          ) : (
            <span />
          )}
          {perfume.availability ? (
            <span
              className={`uppercase tracking-[0.22em] text-[10px] backdrop-blur px-2 py-1 ${
                perfume.availability === "Esaurito"
                  ? "text-black/60 bg-white/80"
                  : "text-[#9A7B3E] bg-white/80"
              }`}
            >
              {perfume.availability}
            </span>
          ) : null}
        </div>
      </div>

      <div className="pt-5 flex items-start justify-between gap-4">
        <div className="min-w-0">
          <div className="uppercase tracking-[0.22em] text-[10px] text-[#C5A059] mb-1.5 truncate">
            {perfume.brand || "Marca da inserire"}
          </div>
          <h3 className="font-heading text-xl md:text-2xl tracking-tight leading-tight truncate">
            {displayName}
          </h3>
        </div>
        {perfume.price ? (
          <div className="font-heading text-lg md:text-xl tracking-tight shrink-0">
            {perfume.price}
          </div>
        ) : null}
      </div>
    </Link>
  );
};

export default ProductCard;
